import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
import axios from 'axios';

import API from '../../config/api';

const DEFAULT_FAQS = [
  {
    question: "Is this bracelet and divine item suitable for everyday wear?",
    answer: "Yes, crafted for daily wear. Just avoid contact with water, perfumes and harsh chemicals to preserve the metal finish and sanctity."
  },
  {
    question: "Has the product been energised before shipping?",
    answer: "Yes — every item undergoes Prana Pratishtha and Vedic mantras performed by qualified pandits before dispatch."
  },
  {
    question: "What is your return and exchange policy?",
    answer: "We offer a 7-day easy return from the date of delivery, provided the product is unused and in its original packaging."
  },
  {
    question: "Do you offer Cash on Delivery (COD)?",
    answer: "Yes, COD is available across most PIN codes in India."
  },
  {
    question: "How long will delivery take?",
    answer: "Orders are typically delivered within 4–7 business days, Pan-India."
  }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const [faqs, setFaqs] = useState(DEFAULT_FAQS);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await axios.get(`${API}/faqs`);
        if (Array.isArray(response.data) && response.data.length > 0) {
          setFaqs(response.data);
        }
      } catch (err) {
        console.error('Error loading homepage FAQs:', err);
      }
    };
    fetchFaqs();
  }, []);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-12 bg-[#FBF4E7] border-t border-[#E7D9BC]">
      <div className="max-w-4xl mx-auto">
        
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-xs font-bold uppercase tracking-widest text-[#B85A15]">
            QUESTIONS
          </span>
          <h2 className="font-serif-heading text-3xl sm:text-4xl md:text-5xl font-bold text-[#4E1225] mt-1">
            Frequently Asked Questions
          </h2>
          <div className="flex items-center justify-center gap-2 mt-3">
            <span className="w-10 h-px bg-[#B98B3E]" />
            <span className="w-2 h-2 bg-[#B98B3E] rotate-45" />
            <span className="w-10 h-px bg-[#B98B3E]" />
          </div>
        </div>

        {/* Accordion List */}
        <div className="space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="bg-[#FFFFFF] border border-[#E7D9BC] rounded-xl overflow-hidden transition-all duration-200 shadow-xs"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-5 py-4 text-left flex items-center justify-between space-x-4 focus:outline-none"
                  aria-expanded={isOpen}
                >
                  <span className="font-body text-sm sm:text-base font-semibold text-[#2A1F16]">
                    {faq.question}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-[#6E1B34] transition-transform duration-200 flex-shrink-0 ${
                      isOpen ? 'transform rotate-180' : ''
                    }`}
                  />
                </button>

                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.2 }}
                    >
                      <div className="px-5 pb-4 text-xs sm:text-sm text-[#83725B] leading-relaxed border-t border-[#E7D9BC]/50 pt-3">
                        <p>{faq.answer}</p>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default FAQSection;
